import {
  ChakraTheme,
  ComponentStyleConfig,
  ThemeComponentProps,
} from '@chakra-ui/react'

const inputBaseStyle = {
  '::placeholder': {
    color: 'neutral.50',
  },
  color: 'deepPurple',
  fontFamily: 'body',
  fontSize: 'body',
  lineHeight: 'body',
}

const inputDefaultProps = {
  errorBorderColor: 'red.70',
  variant: 'outline',
}

const invalidStyle = {
  boxShadow: 'none',
  outline: '2px solid',
  outlineColor: 'red.70',
  outlineOffset: '-2px',
}

const focusStyle = {
  boxShadow: 'none',
  outline: '3px solid',
  outlineColor: 'blue.50',
  outlineOffset: '-3px',
}

const inputVariantOutline = ({
  isInvalid,
}: ThemeComponentProps<ChakraTheme>) => ({
  _disabled: {
    '::placeholder': {
      color: 'neutral.50',
    },
    bgColor: 'neutral.10',
    borderColor: 'neutral.30',
    cursor: 'initial',
  },
  _focus: isInvalid ? invalidStyle : focusStyle,
  _hover: {
    borderColor: 'deepPurple',
  },
  _invalid: invalidStyle,
  border: '1px solid',
  borderColor: 'neutral.30',
})

const inputSizes = {
  md: {
    field: {
      h: '36px',
    },
  },
}

export const FormError: ComponentStyleConfig = {
  baseStyle: {
    icon: {
      color: 'red.70',
    },
    text: {
      color: 'red.70',
    },
  },
}

export const FormLabel: ComponentStyleConfig = {
  baseStyle: {
    fontSize: 'sm',
    fontWeight: 'normal',
  },
}

export const Input: ComponentStyleConfig = {
  baseStyle: {
    field: inputBaseStyle,
  },
  defaultProps: inputDefaultProps,
  sizes: inputSizes,
  variants: {
    outline: props => ({ field: inputVariantOutline(props) }),
  },
}

export const Select: ComponentStyleConfig = {
  baseStyle: {
    field: inputBaseStyle,
  },
  defaultProps: inputDefaultProps,
  sizes: inputSizes,
  variants: {
    outline: props => ({ field: inputVariantOutline(props) }),
  },
}

export const Textarea: ComponentStyleConfig = {
  baseStyle: inputBaseStyle,
  defaultProps: inputDefaultProps,
  variants: {
    outline: props => inputVariantOutline(props), // not a multipart object
  },
}
